import I18n from 'i18n-js';

import { tutorialsSelector } from '@lootboy/lib/slices/tutorials';

import { CircleLoader } from '~/components/atoms/CircleLoader';
import { ListContainer } from '~/components/atoms/ListContainer';
import { ScrollContainer } from '~/components/atoms/ScrollContainer';
import { MenuViewHeader } from '~/components/MenuViewHeader';

import { ITutorial } from '~/interfaces/ITutorial';
import { useTutorials } from '~/redux/selectors';

import Tutorial from './Tutorial';

import styles from './TutorialsPopup.module.scss';

export function TutorialsPopup(): JSX.Element {
  const { loading, items }: { loading: boolean; items: Array<ITutorial> } =
    useTutorials(tutorialsSelector);

  return (
    <>
      <MenuViewHeader title={I18n.t('MenuView_help_tutorials_bc')} />
      <ScrollContainer resizable>
        <section className={styles.container}>
          <h3 className={styles.headline}>
            {I18n.t('MenuView_help_tutorials_how_to')}
          </h3>
          <ListContainer>
            {loading ? (
              <CircleLoader className={styles.loader} />
            ) : (
              items.map((tutorial) => (
                <Tutorial
                  tutorial={tutorial}
                  key={tutorial._id}
                  className={styles.tutorial}
                />
              ))
            )}
          </ListContainer>
        </section>
      </ScrollContainer>
    </>
  );
}
